// Central content + config for MJG Promotions. Replace placeholders marked CLIENT-TODO.
import {
  Warehouse, Shirt, LayoutPanelTop, CalendarClock, Printer, MonitorSmartphone,
  PackageCheck, Boxes, Truck, ClipboardCheck, Newspaper,
} from "lucide-react";

export const COMPANY = {
  name: "MJG Promotions",
  domain: "mjgpromotions.com",
  address: "24 K Commerce Road, Fairfield, NJ 07004",
  addressLine1: "24 K Commerce Road",
  addressLine2: "Fairfield, NJ 07004",
  phone: "973-575-8877",
  phoneHref: "tel:+19735758877",
  fax: "973-575-6677",
  email: "info@mjgpromotions.com",
  emailHref: "mailto:info@mjgpromotions.com",
  tagline: "One partner to produce, store, manage, prepare, and deliver the branded assets your organization needs.",
};

export const PORTAL_URL = "/client-portal";
export const PROMO_PORTAL_URL = "https://mjgpromotions.espwebsite.com/";
export const FULFILLMENT_PORTAL_LOGIN_URL = "https://www.exhibitforce.com/CLIENTS/default.asp";

export const IMAGES = {
  heroWarehouse: "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  warehouseAisle: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  warehouseTablet: "https://images.unsplash.com/photo-1781559818983-c32838ee3d55?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  warehouseWalk: "https://images.unsplash.com/photo-1664382953403-fc1ac77073a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  packing: "https://images.unsplash.com/photo-1449247666642-264389f5f5b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  packStation: "https://images.unsplash.com/photo-1589792923962-537704632910?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  aisleSilhouette: "https://images.unsplash.com/photo-1592228533283-d78f7c1cf453?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  apparelRack: "https://images.unsplash.com/photo-1781614651872-15da79800273?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  apparelSweatshirt: "https://images.unsplash.com/photo-1635131695955-ce4d071a5211?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  caps: "https://images.unsplash.com/photo-1786561047807-34e4019649a6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  exhibit: "https://images.unsplash.com/photo-1761225646548-bc92fea0dc72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  exhibitCrowd: "https://images.unsplash.com/photo-1778402566957-c21d77a67d0d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  eventStage: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  conference: "https://images.unsplash.com/photo-1531058020387-3be344556be6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  collateral: "https://images.unsplash.com/photo-1676287567550-e875cf4af133?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  brochures: "https://images.unsplash.com/photo-1769893715447-8f12c382e49c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  printHero: "https://images.unsplash.com/photo-1503694978374-8a2fa686963a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  printDigitalCard: "https://images.unsplash.com/photo-1693031630369-bd429a57f115?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  printOffsetCard: "https://images.unsplash.com/photo-1693031630157-7ecc8d06de63?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  printFinishingCard: "https://images.unsplash.com/photo-1693031630189-a39e6d70bf22?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  printDesignCard: "https://images.unsplash.com/photo-1581079289196-67865ea83118?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  printDigital: "https://images.unsplash.com/photo-1693031630146-568e2f72db0e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  printOffset: "https://images.unsplash.com/photo-1729944950511-e9c71556cfd4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  printFinishing: "https://images.unsplash.com/photo-1422036306541-00138cae4dbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  printDesign: "https://images.unsplash.com/photo-1642480532034-362360552ccb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  // AI-generated placeholders (labeled conceptual where relevant)
  merchFlatlay: "https://static.prod-images.emergentagent.com/jobs/671ab710-7dbc-40cd-aa3a-01162bb44980/images/94d4c462b859b8164b7128b4d5becf9c0376c228eeb663af01911969b4d38e9d.jpeg",
  kitting: "https://static.prod-images.emergentagent.com/jobs/671ab710-7dbc-40cd-aa3a-01162bb44980/images/dcee112367678450531d9f3d622ece208fb903b59867c9968b728478f0f31957.jpeg",
  portalDashboard: "https://static.prod-images.emergentagent.com/jobs/671ab710-7dbc-40cd-aa3a-01162bb44980/images/dc239bace3708dc224c4c3d5acb0274d41e18247b392dab52d77d43304d469f4.jpeg",
};

export const SERVICES = [
  {
    slug: "/fulfillment-warehousing",
    icon: Warehouse,
    title: "Fulfillment & Warehousing",
    short: "Storage, inventory control, kitting, pick-and-pack, inspection, fulfillment, and shipping.",
    flagship: true,
  },
  {
    slug: "/promotional-products-apparel",
    icon: Shirt,
    title: "Apparel & Promotional Products",
    short: "In-house apparel production, uniforms, branded merchandise, gifts, and giveaways.",
  },
  {
    slug: "/trade-show-exhibits",
    icon: LayoutPanelTop,
    title: "Trade Show Exhibits",
    short: "Custom and rental exhibits, portable displays, graphics, logistics, install, and dismantle.",
  },
  {
    slug: "/event-project-management",
    icon: CalendarClock,
    title: "Event Management",
    short: "Planning, scheduling, show services, shipping, setup, teardown, and onsite coordination.",
  },
  {
    slug: "/marketing-collateral",
    icon: Printer,
    title: "Marketing Collateral",
    short: "Printing, signage, event kits, packaging, assembly, and distribution.",
  },
  {
    slug: "/printing-services",
    icon: Newspaper,
    title: "Printing Services",
    short: "Digital and offset printing, professional finishing, and in-house graphic design.",
  },
  {
    slug: PORTAL_URL,
    icon: MonitorSmartphone,
    title: "Cloud-Based Portal",
    short: "Centralized inventory visibility, ordering, requests, fulfillment, and asset management.",
    external: true,
  },
];

export const NAV_SERVICES = SERVICES.filter((s) => !s.external);

export const PROCESS = [
  { num: "01", title: "Store", desc: "Keep branded assets organized in one managed location.", icon: Boxes },
  { num: "02", title: "Prepare", desc: "Inspect, kit, pack, and stage each order or event shipment.", icon: PackageCheck },
  { num: "03", title: "Fulfill", desc: "Ship materials where they need to go and update inventory.", icon: Truck },
  { num: "04", title: "Manage", desc: "Give authorized teams access through a cloud-based portal.", icon: ClipboardCheck },
];

export const USE_CASES = [
  "Job Fairs", "Trade Shows", "Sales Meetings", "Community Outreach",
  "Recruiting Events", "Employee Programs", "Corporate Gifting", "Multi-Location Activations",
];

export const MARQUEE_WORDS = ["Store", "Prepare", "Fulfill", "Manage", "Deliver", "Produce", "Support"];
